import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Relationship } from "./Relationship";
import { Upload } from "./Upload";
import { List } from "./List";
import { Paragraph } from "./Paragraph";
import { Heading } from "./Heading";
import { Quote } from "./Quote";
import { HorizontalRule } from "./HorizontalRule";
import { Block } from "./Block";
import { Table } from "./Table";
export const RichText = ({ data, options }) => {
    return (_jsx(_Fragment, { children: data.root.children.flatMap((child, index) => {
            switch (child.type) {
                case "paragraph": {
                    return _jsx(Paragraph, { data: child, options: options }, index);
                }
                case "heading": {
                    return _jsx(Heading, { data: child, options: options }, index);
                }
                case "horizontalrule": {
                    return (_jsx(HorizontalRule, { data: child, options: options }, index));
                }
                case "list": {
                    return _jsx(List, { data: child, options: options }, index);
                }
                case "quote": {
                    return _jsx(Quote, { data: child, options: options }, index);
                }
                case "block": {
                    return _jsx(Block, { data: child, options: options }, index);
                }
                case "relationship": {
                    return _jsx(Relationship, { data: child, options: options }, index);
                }
                case "upload": {
                    return _jsx(Upload, { data: child, options: options }, index);
                }
                case "table": {
                    return _jsx(Table, { data: child, options: options }, index);
                }
                default: {
                    return options?.unknown ? options.unknown(child) : undefined;
                }
            }
        }) }));
};
